import React from 'react'
import { cn } from 'src/lib/utils'

export default function ContentCircle({className, style, contentClassName, content}) {
  return (
    <div>
        <div style={{style}} className={cn('text-center flex justify-center items-center rounded-full',className)}>
              <div className={contentClassName}>{content}</div>
         </div>
    </div>
  )
}
